module.exports = __webpack_public_path__ + "fonts/Nunito-Bold.1cd294a.ttf";